import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { log } from 'console';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-open-college-addmission',
  templateUrl: './open-college-addmission.component.html',
  styleUrls: ['./open-college-addmission.component.scss']
})
export class OpenCollegeAddmissionComponent implements OnInit {
  SessionCutOffList: any;
  totalItems: any;
  message: string;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  OpenAdmSearchForm
  CourseLevelList: any;
  filteredListCourseLevel: any;
  courseData: any;
  filteredListCourse: any;
  collegedataList=[];
  filteredListCollege=[];
  CoCode: any;
  sessionList: any[] = [];
  filteredSessionList: any[] = [];
  selectedSessionId: any;
  constructor(private fb: FormBuilder, private modalPopupService: ModalpopService,
    public umsService: UmsService, private spinner: NgxSpinnerService) { }
  dialogRef: MatDialogRef<any>;
  openAddmision: FormGroup;
  saveBtn = false;
  AdmClosed = false
  ngOnInit(): void {
    sessionStorage.getItem('loginId');
    this.openSessionActivities();
    this.fetchAllSessionCutoff()
    this.getCuttoffDate();
    this.getCourseLevelData();

    this.OpenAdmSearchForm = this.fb.group({
      SearchString: new FormControl('')
    });
    this.openAddmision= this.fb.group({
      SessionName: new FormControl(''),
      SnName: new FormControl(''),
      CourseLevel: new FormControl(''),
      Course: new FormControl(''),
      StuStudyCenter: new FormControl(''),
    });
  }

  openSessionActivities() {
  this.spinner.show();

  const payload = {
    loginId: parseInt(sessionStorage.getItem('loginId'))
  };

  this.umsService.openSessionActivities(payload).subscribe(res => {
  if (res.status) {
  const dataObj = res.data || {};
  const allSessions = (Object.values(dataObj).reduce((acc: any[], val: any) => {

    if (Array.isArray(val)) {
    acc.push(...val);
  } else if (val && typeof val === 'object') {
    acc.push(val);
  }

  return acc;

}, []) as any[]).filter((item: any) => item?.SessionName);

  // Remove duplicate sessions
  this.sessionList = allSessions.filter(
  (value, index, self) =>
    index === self.findIndex(
      x => x.SessionID === value.SessionID
    )
);

  this.filteredSessionList = [...this.sessionList];
}
  this.spinner.hide();

  }, (error: HttpErrorResponse) => {
    this.spinner.hide();
  });
}

  onSessionChange(sessionId: any) {
  this.selectedSessionId = sessionId;

  this.openAddmision.patchValue({
    course: '',
    Branch: '',
    StuDistrictAd: '',
    StuStudyCenter: ''
  });

  // this.showTable = false;

  this.fetchAllSessionCutoff();
}


  fetchAllSessionCutoff() {
    this.spinner.show();
    const payload = {};
    // payload['PageSize'] = this.pageSize;
    // sessionStorage.getItem('session');
    payload['SnNo'] = this.selectedSessionId || sessionStorage.getItem('session');
    payload['InCode'] = 'ADM'
    payload['SearchString'] = ''
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['CoCode'] = '';
    payload['CgCode'] = '';
    let today1 = new Date().setHours(0, 0, 0, 0);
    let today = new Date();
    const newDataArray: any[] = [];
    let newData = [];
    let year = today.getFullYear();
    let month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    let day = String(today.getDate()).padStart(2, '0');
    let todaYDate = `${year}-${month}-${day}`;

    this.umsService.listSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.SessionCutOffList = res.data;
        this.totalItems = res.data[0]?.TotalRecords || 0;

        this.courseData = [];
        
        const uniqueCourses = [];

        res.data.forEach(item => {

          const exists = uniqueCourses.find(
            x => x.CoCode === item.CoCgCoCode
          );

          if (!exists) {
            uniqueCourses.push({
              CoCode: item.CoCgCoCode,
              CoName: item.CoName
            });
          }
        });

        this.courseData = uniqueCourses;
        this.filteredListCourse = [...this.courseData];
      } else {
        this.SessionCutOffList = [];
        this.courseData = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.SessionCutOffList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    });
  }

  
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.fetchAllSessionCutoff();
    this.keypress();
  }


  keypress() {
    this.SessionCutOffList = [];
    let payload = {}
    // payload['SnNo'] = sessionStorage.getItem('session');
    payload['SnNo'] = this.selectedSessionId || sessionStorage.getItem('session');
    payload['InCode'] = 'ADM'
    payload['SearchString'] = this.OpenAdmSearchForm.value['SearchString'];
    payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.SearchSessionCutOff(payload).subscribe(res => {
      if(res.status){
        this.SessionCutOffList  = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.SessionCutOffList = [];
        this.totalItems = 0;
      }
     
    }, (ERROR: HttpErrorResponse) => {
      this.SessionCutOffList = [];
    });
  }
  submit(data) {
    this.spinner.show();
    const payload = {};
    // payload['PageSize'] = this.pageSize;
    payload['LoginId'] = sessionStorage.getItem('loginId');
    payload['SnNo'] = this.selectedSessionId || sessionStorage.getItem('session');
    payload['College'] = data.CoCgCgCode;
    payload['Course'] = data.CoCgCoCode;
    payload['FromDate'] = data.FromDate;
    payload['ToDate'] = data.ToDate;
    payload['Status'] = 'Y';
    this.umsService.applyDate(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.spinner.hide
        let data = {};
        data['message'] = "Applied Succesfully";
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.saveBtn = true;
        this.dialogRef.afterClosed().subscribe((result) => {
          var link = document.createElement('a');
          link.setAttribute("href", "/student-registration-tab");
          link.click()
        });

      } else {
        this.spinner.hide
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.SessionCutOffList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    });
  }

  openConformationModalBox(data1) {
    let data = {}
    data['message'] = 'Are You Sure That You Want Make Registration For ' + data1.CgName + ' For The Course ' + data1.CoName + '.'
    data['title'] = 'Information'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.submit(data1)
      } else {
        // this.next.emit();

        this.ngOnInit()
      }
    });
  }

  getCuttoffDate() {
    let payload = {};
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getCuttoffDate(payload).subscribe((res) => {
      if (res.status) {
        this.saveBtn = true;
      } else {
        this.saveBtn = false;
      }
    })
  }

  getCourseLevelData() {
    this.CourseLevelList = [];
    this.filteredListCourseLevel = [];
    this.spinner.show();
    this.umsService.getCourseLevel().subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.CourseLevelList = res.data;
        this.filteredListCourseLevel = this.CourseLevelList.slice();
      }
      else{
        this.spinner.hide();
        this.CourseLevelList = [];
        this.filteredListCourseLevel = [];
      }
    
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getCollegeData(CoCode) {
  this.collegedataList = [];
  this.filteredListCollege = [];
    this.spinner.show();

  const payload: any = { CoCode };

  this.fetchAllSessionCutoff2(CoCode); 

    this.openAddmision.get('StuStudyCenter').reset();

  this.umsService.CourseWiseCollege(payload).subscribe(
    (res) => {
        this.spinner.hide();

      if (res.status) {
        this.collegedataList = res.data.filter((college: any) =>
          this.SessionCutOffList.some(
            (cutoff: any) =>
              cutoff.CoCgCgCode === college.CgCode &&
              cutoff.CoCgCoCode === college.CoCode
          )
        );        
        this.filteredListCollege = this.collegedataList.slice();
   
      } else {
        this.collegedataList = [];
        this.filteredListCollege = [];
      }
    },
    (error: HttpErrorResponse) => {
        this.spinner.hide();
    }
  );
}

  getCourseData(cdType,cdCode) {
    this.spinner.show();
    this.collegedataList =[];
    this.filteredListCollege=[]
    const payload = {};
    payload['CdType'] = cdType;
    payload['CdCode'] = cdCode;
    payload['SnNo'] = sessionStorage.getItem('session');
    this.fetchOpenRegistrationListByCourseLevel(cdCode);
    this.openAddmision.get('StuStudyCenter').reset();
    this.umsService.getCourseData(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
          this.courseData = res.data.filter((course: any) =>
          this.SessionCutOffList.some(
            (cutoff: any) =>
              cutoff.CoCgCoCode === course.CoCode
          )
        );
        this.filteredListCourse = this.courseData.slice();
      } else {
        this.courseData = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  fetchAllSessionCutoff2(CoCode) {
    this.spinner.show();
    const payload = {};
    this.CoCode = CoCode
    payload['SnNo'] = this.selectedSessionId || sessionStorage.getItem('session');
    payload['InCode'] = 'ADM'
    payload['SearchString'] = ''
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['CoCode'] = CoCode;
    payload['CgCode'] = '';
    let today1 = new Date().setHours(0, 0, 0, 0);
    let today = new Date();
    const newDataArray: any[] = [];
    let newData = [];
    let year = today.getFullYear();
    let month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    let day = String(today.getDate()).padStart(2, '0');
    let todaYDate = `${year}-${month}-${day}`;

    this.umsService.listSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.SessionCutOffList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      } else {
        this.SessionCutOffList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.SessionCutOffList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    });
  }

  fetchOpenRegistrationListByCourseLevel(cdCode) {
    this.spinner.show();
    const payload = {};
    payload['SnNo'] = sessionStorage.getItem('session');
    payload['InCode'] = 'ADM'
    payload['SearchString'] = ''
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['CoCode'] = '';
    payload['CgCode'] = '';
    payload["CdCode"] = cdCode
    let today1 = new Date().setHours(0, 0, 0, 0);
    let today = new Date();
    const newDataArray: any[] = [];
    let newData = [];
    let year = today.getFullYear();
    let month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    let day = String(today.getDate()).padStart(2, '0');
    let todaYDate = `${year}-${month}-${day}`;

    this.umsService.listSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.SessionCutOffList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      } else {
        this.SessionCutOffList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.SessionCutOffList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    });
  }


  fetchAllSessionCutoff3(CgCode) {
    this.spinner.show();
    const payload = {};
    // payload['PageSize'] = this.pageSize;
    // sessionStorage.getItem('session');
    payload['SnNo'] = this.selectedSessionId || sessionStorage.getItem('session');
    payload['InCode'] = 'ADM'
    payload['SearchString'] = ''
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['CoCode'] = this.CoCode;
    payload['CgCode'] = CgCode;
    let today1 = new Date().setHours(0, 0, 0, 0);
    let today = new Date();
    const newDataArray: any[] = [];
    let newData = [];
    let year = today.getFullYear();
    let month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    let day = String(today.getDate()).padStart(2, '0');
    let todaYDate = `${year}-${month}-${day}`;

    this.umsService.listSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.SessionCutOffList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      } else {
        this.SessionCutOffList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.SessionCutOffList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    });
  }
}